<template>
  <div>
    <!-- breadcrumb start -->
    <div class="breadcrumb-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="page-title">
              <h2>Zerofast智能家居专家</h2>
            </div>
          </div>
          <div class="col-sm-6">
            <nav aria-label="breadcrumb" class="theme-breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="//cloud.ai-ifast.com/index.html">Home</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">智能组网应用</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!-- breadcrumb End -->
    <!-- section start -->
    <section class="section-b-space">
      <div class="collection-wrapper">
        <div class="container">
          <div class="row data-sticky_parent">
            <div class="col-lg-12 col-sm-12 col-xs-12">
              <div class="container-fluid p-0">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="row">
                      <div class="col-12 product_img_scroll image-scroll" data-sticky_column>
                        <div style="display: flex; justify-content: center;">
                          <img :src="goods.pic" style="max-width: 70%; max-height: 600px; object-fit: contain;" alt="" class="img-fluid blur-up lazyload">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 rtl-text">
                    <div class="product-right pro_sticky_info" data-sticky_column>
                      <h2>{{ goods.name }}</h2>
                      <h3 class="price-detail" v-if="goods.plan.price">
                        ￥{{ goods.plan.price | number('0,0.00') }}元
                      </h3>
                      <h3 class="price-detail" v-else>
                        ￥ -元
                      </h3>
                      <div class="rating-section">
                        <div class="rating">
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                        </div>
                      </div>
                      <div class="label-section">
                        <span class="badge badge-theme-color" v-for="tag in goods.plan.tags" :key="tag" style="margin: 0px 5px;">{{ tag }}</span>
                      </div>
                      <div id="selectSize" class="addeffect-section product-description border-product">
                        <div class="size-box">
                          <ul>
                            <li v-for="plan in plans" :key="plan.plan_id" :class="{active: plan.plan_id === goods.plan.plan_id}">
                              <a @click="handlePlan(plan)" :class="{'plan-active': plan.plan_id === goods.plan.plan_id, 'plan': plan.plan_id !== goods.plan.plan_id }" v-html="plan.name"></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="product-buttons">
                        <a @click="quickBuy" class="btn btn-solid hover-solid btn-animation">
                          <i class="fa fa-credit-card-alt fz-16 me-2" aria-hidden="true"></i>立即购买
                        </a>
                        <a @click="addCart" class="btn btn-solid">
                          <i class="fa fa-shopping-cart me-1" aria-hidden="true"></i> 加入购物车
                        </a>
                      </div>
                      <div class="border-product">
                        <h6 class="product-title"></h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Section ends -->

    <!-- product-tab starts -->
    <section class="tab-product pt-0 m-0">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-lg-12">
            <ul class="nav nav-tabs nav-material" id="top-tab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" id="top-home-tab" data-bs-toggle="tab" href="#top-home" role="tab" aria-selected="true">
                  <i class="icofont icofont-ui-home"></i>介绍 </a>
                <div class="material-border"></div>
              </li>
            </ul>
            <div class="tab-content nav-material" id="top-tabContent">
              <div class="tab-pane fade show active" id="top-home" role="tabpanel" aria-labelledby="top-home-tab">
                <div class="product-tab-discription" style="display: flex; justify-content: center;">
                  <div class="part" style="width: 800px;">
                    <h3>抢先体验解锁：</h3>
                    <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">
                      1. 石头、科沃斯、追觅、云鲸，扫地机专用
                    </li>
                    <br/>
                    <br/>
                    <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">
                      2. 包含自研解锁软件 + 使用教程（网盘下载），需要有Windows10系统电脑，电脑网络环境需连接路由器WiFi2.4G频段或有线网络。
                    </li>
                    <br/>
                    <br/>
                    <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">
                      3. 官网下单立即解锁，无需等待
                    </li>
                    <br/>
                    <br/>
                    <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">
                      4. 一年530元即可抢先体验解锁
                    </li>
                    <br/>
                    <br/>
                    <li style="font-size: 16px; color: #6d6d6d; line-height: 30px;">
                      【特别提醒】：软件套餐购买后自动发货不可退款，如升级硬件套餐，可抵扣硬件套餐一次
                    </li>
                    <br/>
                    <br/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- product-tab ends -->

    <!-- product section start -->
    <section class="section-b-space ratio_asos">
      <div class="container">
        <div class="row">
          <div class="col-12 product-related">
            <h2></h2>
          </div>
        </div>
      </div>
    </section>
    <!-- product section end -->

    <!-- tap to top start -->
    <div class="tap-top">
      <div @click="showCustomer">
        <!--        <i class="fa fa-angle-double-up"></i>-->
        <i class="fa fa-wechat"></i>
      </div>
    </div>
    <!-- tap to top end -->
    <!-- added to cart notification -->
    <div :class="{'added-notification': true, 'show': showAddCart}">
      <img :src="goods.pic" class="img-fluid" alt="">
      <h3>加入购物车</h3>
    </div>
    <!-- added to cart notification -->
    <a-modal title="客服微信" v-model="showCustomerWechat" :footer="null">
      <div style="display: flex; justify-content: center;">
        <img src="https://www.zerofast.net/assets/images/wechat.png" style="width: 240px;" alt="客服微信">
      </div>
    </a-modal>
    <a-modal title="登录" v-model="showWechat" :footer="null" style="display: flex; justify-content: center;">
      <LoginSection :wechat="wechat"></LoginSection>
    </a-modal>

  </div>
</template>

<script>
import { setCart, getCart, getToken } from '@/libs/util'
import { baseMixin } from '@/libs/app-mixin'
import config from '@/config'
import LoginSection from '@/components/blocks/LoginSection'
import { getDesk } from '@/api/product'

export default {
  name: 'productDesk',
  mixins: [baseMixin],
  components: {
    LoginSection
  },
  data () {
    return {
      showAddCart: false,
      showCustomerWechat: false,
      showWechat: false,
      goods: {
        pic: 'https://www.hrfls.net/uploads/images/42eea5a8fa9e9fe24d0509b506f7f201.jpeg',
        plan: {
          plan_id: '',
          name: '',
          price: 0,
          discount: 0,
          tags: []
        },
        service: {
          service_id: '',
          name: '',
          price: 0,
          discount: 0,
          tags: []
        },
        qty: 1
      },
      cart: [],
      plans: []
    }
  },
  methods: {
    getDesk () {
      getDesk().then(res => {
        if (typeof res.result.goods === 'undefined') {
          setTimeout(() => {
            this.getPlans()
          }, 1000)
          return false
        }
        this.goods = res.result.goods
        this.plans = res.result.plans
      })
    },
    showCustomer () {
      this.showCustomerWechat = true
    },
    handlePlan (plan) {
      this.goods.plan = plan
    },
    quickBuy () {
      if (this.goods.plan.plan_id === '') {
        this.$message.info('请选择套餐')
        return false
      }
      if (!this.checkAuth()) {
        return false
      }
      this.cart = []
      this.addCart()
      setTimeout(() => {
        location.href = '/#/checkout'
      }, 100)
    },
    addCart () {
      if (this.goods.plan.plan_id === '') {
        this.$message.info('请选择套餐')
        return false
      }
      this.showAddCart = true
      setTimeout(() => {
        this.showAddCart = false
      }, 5000)

      let flag = true
      this.cart.forEach(v => {
        if (v.id === this.goods.plan.plan_id + '-' + this.goods.service.service_id) {
          flag = false
          v.qty += this.goods.qty
        }
      })
      if (flag === true) {
        this.cart.push({
          id: this.goods.plan.plan_id + '-' + this.goods.service.service_id,
          plan: {
            tag: this.goods.plan.tag,
            plan_id: this.goods.plan.plan_id,
            name: this.goods.plan.name.replaceAll('<br/>', ''),
            price: this.goods.plan.price,
            discount: this.goods.plan.discount,
            sign: this.goods.plan.sign
          },
          service: this.goods.service,
          pic: this.goods.pic,
          qty: this.goods.qty
        })
      }
    },
    getWechatUrl () {
      const token = getToken()
      if (token === false) {
        const redirect = encodeURI(config.ssoUrl)
        if (this.checkEnv() === 'web') {
          const appid = 'wx56610615281b2c87'
          const state = 'member'
          this.wechat.url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=snsapi_login&state=${state}#wechat_redirect`
        } else if (this.checkEnv() === 'wechat') {
          const appid = 'wx3cf92c62c10802be'
          const state = 'h5'
          this.wechat.url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
        }
        return false
      }
    },
    checkAuth () {
      this.token = getToken()
      if (this.token === false) {
        if (this.checkEnv() === 'wechat') {
          location.href = this.wechat.url
        } else {
          this.showWechat = true
        }
        return false
      }
      return true
    }
  },
  mounted () {
    this.getDesk()
    this.cart = getCart()
  },
  watch: {
    cart: {
      handler (newValue, oldValue) {
        this.$parent.cart = this.cart
        if (this.cart.length > 0) {
          setCart(this.cart)
        }
      }
    }
  }
}
</script>

<style scoped>
.plan-active {
  color: #fff;
}
.plan {
  color: #222;
}
</style>



// WEBPACK FOOTER //
// src/components/Product/Desk.vue